<!-- 
    radio单选框
    author:xxk 
    https://element.eleme.io/#/zh-CN/component/radio
 -->
<template>
  <el-radio-group v-model="valueModel" v-bind="radioGroupPropsResult" class="AppRadioGroup-root">
    <el-radio v-bind="radioProps" v-for="item in radioList" :key="item.id" :label="item.id">{{item.name}}</el-radio>
  </el-radio-group>
</template>
<script>
  import {vModel} from '@/mixins/vModel.js';
  export default {
    name: 'AppRadioGroup',
    mixins:[vModel],
    props: {
      // v-model
      value: { type: [String, Array], default: '' },
      // radioGroup组件属性
      radioGroupProps: { type: Object, default() { return {}; } },
      // radioP组件属性
      radioProps: { type: Object, default() { return {}; } },
      // 列表
      radioList: { type: Array, default() { return []; } },
    },
    computed:{
      // 组件属性合并结果
      radioGroupPropsResult(){
        return Object.assign(
          {
            clearable: true,
          },
          this.$attrs,
          this.radioGroupProps,
        );
      }
    },
  };
</script>
<style scoped lang="less"></style>
